var $ = require('jquery');
import { gsap } from "gsap";
var currentPagePos = 0;

$(window).on('load', function() {
    setTimeout(()=> {
        setHeaderHeight();
        stickyNav();
    }, 625);
})

$(window).on('resize scroll', function() {
    setTimeout(()=> {
        setHeaderHeight();
    }, 625);
}).trigger('resize');

$(window).on('resize', function() {

    if ( $('.site-header').hasClass('search-open') && $(window).width() >= 991 ) {
        $('.site-header__search-close').trigger('click');
    }

    if ( $(window).width() <= 991 ) {
        if ( $('.site-header').hasClass('site-header--condensed') ) {
            $('.site-header').removeClass('site-header--condensed');
            $('.site-header input.search-desktop').attr('placeholder', 'Search');
            
        }
    } else {
        $('.site-header input.search-desktop').attr('placeholder', 'Find products, services, stories, and more');
        gsap.set($('#menu-primary-navigation > .menu-item'), {
            clearProps: true,
        })
        $('body.site-header--menu-open.fixed').removeClass('site-header--menu-open fixed');
        $('.hamburger.is-active').removeClass('is-active');
    }
}).trigger('resize');

$(window).on('scroll', function() {
    stickyNav();
})

// add click events
$('.site-header__search-open, .site-header__search-close').on('click', toggleSearch);
$('.menu-item.menu-item-has-children span').on('click', toggleMegaMenu);

// login menu
$('.site-header__login-menu .button').on('click', function() {
    console.log(document.body.classList);
    $('.site-header__login-menu').toggleClass('active');
    
    // close any open megamenus
    $('.megamenu.active').removeClass('active');
    $('#menu-primary-navigation .menu-item.active').removeClass('active');

    // toggle classes for login menu and site header background
    $(this).siblings('.site-header__login-menu-container').toggleClass('active');
    // if ( $(this).siblings('.site-header__login-menu-container').hasClass('active') ) {
    //     $('.site-header').addClass('site-header--megamenu-open');
    // } else {
    //     setTimeout(()=>{
    //         $('.site-header').removeClass('site-header--megamenu-open');
    //     }, 400);
    // }
})


// handles nested back buttons inside megamenus ( lvl 2 )
$('.menu-item-back').on('click', function(e) {
    e.stopPropagation();
    if ( $(window).width() <= 991 ) {
        $('.menu-item.active').removeClass('active');
    }
    $(this).closest('.megamenu.active').removeClass('active');
    $(this).closest('.site-header__login-menu-container').removeClass('active');
});

// click for hamburger menu for mobile and condensed desktop nav
$('.site-header__menu-toggle button').on('click', () => {
    
    $('.site-header__menu-toggle button').toggleClass('is-active');

    // if tablet or smaller, open menu in mobile form
    if ( $(window).width() <= 1024 )  {
        $('body').toggleClass('site-header--menu-open');
        
        $('.megamenu.active').removeClass('active');

        if ( $('body').hasClass('site-header--menu-open') ) {
            currentPagePos = $(window).scrollTop();
            $('.site-header__menu-toggle button').css('pointer-events', 'none');
            
            $('.site-header').addClass('site-header--megamenu-open');

            var animateItems = gsap.to($('#menu-primary-navigation > .menu-item'), {
                stagger: 0.2,
                opacity: 1,
                y: 0,
                duration: 0.45,
                ease: "power1.out",
                clearProps: true,
                onComplete: () => {
                    $('body').addClass('fixed');
                    $('.site-header__menu-toggle button').css('pointer-events', 'initial');
                }
            })

        } else {
            $('#menu-primary-navigation > .menu-item')
            $('body').removeClass('fixed');
            window.scrollTo({
                top: currentPagePos,
                behavior: 'instant',
            });

            $('.site-header').removeClass('site-header--megamenu-open');
            gsap.set($('#menu-primary-navigation > .menu-item'), {
                opacity: 0,
                y: 15,
                delay: 0.4,
            })

            $('.site-header__menu-toggle button').css('pointer-events', 'initial');
        }
    } else {

        // if desktop show nav normally
        $('.site-header__navigation').toggleClass('active');
    }

})

// show search button when the user types in the search field
$('.site-header__search-form input[type="text"]').on('keyup', function() {
    if ( $('.site-header__search-form input[type="text"]').val() != '' ) {
        $('.site-header__search-form .button').addClass('show');
    } else {
        $('.site-header__search-form .button').removeClass('show');
    }
})

$('.menu-item.menu-item-has-children span, .site-header__login-menu').on('click', function() {
    if ( $(window).width() <= 991 ) {
        $('.site-header__navigation, .site-header__login-menu-container').animate({
            scrollTop: 0,
        })
    }
})

// handles when to make nav sticky and where it should be placed.
function stickyNav() {
    let headerHeight = getComputedStyle(document.querySelector(':root')).getPropertyValue('--header-height');

    if ( $(window).width() >= 991 ) {

        if ( $(window).scrollTop() >= 50 ) {
            $('.site-header').addClass('site-header--condensed');
            if ( $('.site-header').find(".menu .active, .megamenu .active").length ) {
                $('.site-header').find(".menu .active, .megamenu .active").each(function() {
                    $(this).removeClass('active');
                })
            }
        } else {
            $('.site-header').removeClass('site-header--condensed');
        }
    }
}

// handles megamenu 
function toggleMegaMenu(e) {
    e.stopPropagation();
    let item = $(e.currentTarget).closest('.menu-item');
    let activeItem = $('.megamenu.active');
    
    
    // if a top level item
    if ( item.hasClass('menu-item-depth-0') ) {

        // if the same top level menu item has been clicked, close the megamenu
        if ( activeItem.closest('.menu-item')[0] == item[0] ) { 
            item.removeClass('active');
            item.find('.megamenu.active').removeClass('active');

            setTimeout(()=>{
                $('.site-header').removeClass('site-header--megamenu-open');
            }, 400);
        } else {
            $('.site-header').addClass('site-header--megamenu-open');

            // if a different menu item has been clicked, close the current open one and one this one
            activeItem.removeClass('active');
            $('.menu-item-depth-0.active').removeClass('active');
            item.addClass('active');
            item.children('.megamenu').addClass('active');
        }
    } else {

        // if not a top level item
        item.children('.megamenu').addClass('active');
    }
}

// handles search field toggle and animations
function toggleSearch(e) {
    e.stopPropagation();
    $('#search-input').trigger('focus');

    let target = $(e.currentTarget);
    var tl = gsap.timeline();        
    if ( target.hasClass('site-header__search-open') ) {
        // $('.site-header__search-close').css('pointer-events', 'none');
        
        target.closest('.site-header').addClass('search-open');
        tl.to($('.site-header__search-open'), {
            opacity: 0,
            duration: 0.1,
            // pointerEvents: 'none',
            ease: 'power2.out'
        })
        if ( $(window).width() > 991 ) {
            tl.to($('#menu-primary-navigation'), {
                opacity: 0,
                duration: 0.1,
                onComplete: function() {
                    $('#menu-primary-navigation').css('pointer-events', 'none');
                }
            })
        } else {
            tl.to($('.site-header__logo'), {
                opacity: 0,
                duration: 0.2
            })
        }
        tl.to($('.site-header__search-option'), {
            opacity: 0,
            duration: 0.1,
        }, '-=0.1')
        tl.to($('.site-header__search-form'), {
            x: '-100%',
            duration: 0.4,
            opacity: 1,
        }, '-=0.2')

        
    } else if ( target.hasClass('site-header__search-close') ) {
        target.closest('.site-header').removeClass('search-open');
        tl.to($('.site-header__search-form'), {
            opacity: 0,
            duration: 0.275,
        })
        .to($('.site-header__search-option'), {
            opacity: 1,
            duration: 0.1,
        })
        if ( $(window).width() > 991 ) {
            tl.to($('#menu-primary-navigation'), {
                opacity: 1,
                duration: 0.175,
                onComplete: function() {
                    $('#menu-primary-navigation').css('pointer-events', 'initial');
                }
            }, '-=0.3')
        } else {
            tl.to($('.site-header__logo'), {
                opacity: 1,
                duration: 0.2
            })
        }
        tl.to($('.site-header__search-open'), {
            opacity: 1,
            // pointerEvents: 'initial',
            duration: 0.1,
            onComplete: function() {
                gsap.to('.site-header__search-form', { x: 0 })
            }
        }, '-=0.2')

    }
}

// set headerHeight css variable
function setHeaderHeight() {
    document.querySelector(':root').style.setProperty('--header-height', $('.site-header').outerHeight() + 'px');
    document.querySelector(':root').style.setProperty('--alert-height', ($('.site-alert').length ? $('.site-alert').outerHeight() : 0) + 'px');
    // let headerHeight = getComputedStyle(document.querySelector(':root')).getPropertyValue('--header-height');
    // console.log(headerHeight)
}



// back button for search
$(".page-search__navigation-link").on('click', (e) => {
    e.preventDefault();
    history.back();
});


$(".site-alert__close").on("click", function() {
    $(this).closest('.site-alert').remove();
    $('body').removeClass('body--has-alert');

    setHeaderHeight();
})